module.exports = __webpack_public_path__ + "img/icon-lvip.4ab13434.png";